module.exports = {
	"pagination": {
		"DescribeMappedResourceConfiguration": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "MappedResourceConfigurationList"
		},
		"ListEdgeAgentConfigurations": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "EdgeConfigs"
		},
		"ListSignalingChannels": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "ChannelInfoList"
		},
		"ListStreams": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken",
			"result_key": "StreamInfoList"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/kinesisvideo-2017-09-30.paginators.json
// module id = 2172
// module chunks = 0